<script setup>
import {onMounted, ref, defineProps, defineEmits} from "vue";
import useTools from "@/use/Tools";

defineProps({
    events: Array,
});

const emit = defineEmits(["updateRange", "showEvent", "dayClick", "timeClick"]);

const {$refs} = useTools();

const focus = ref('');
const type = ref('week');
const typeToLabel = ref({
    month: 'Mois',
    week: 'Semaine',
    day: 'Jour',
    '4day': '4 Jours',
});
const selectedEvent = ref({});
const selectedElement = ref(null);
const selectedOpen = ref(false);

function viewDay({date}) {
    focus.value = date
    type.value = 'day'
}

function getEventColor(event) {
    return event.color
}

function setToday() {
    focus.value = ''
}

function prev() {
    $refs.calendar.prev()
}

function next() {
    $refs.calendar.next()
}

function showEvent({nativeEvent, event}) {
    emit('showEvent', event)
    const open = () => {
        selectedEvent.value = event
        selectedElement.value = nativeEvent.target
        requestAnimationFrame(() => requestAnimationFrame(() => selectedOpen.value = true))
    }

    if (selectedOpen.value) {
        selectedOpen.value = false
        requestAnimationFrame(() => requestAnimationFrame(() => open()))
    } else {
        open()
    }

    nativeEvent.stopPropagation()
}

function updateRange({start, end}) {
    emit('updateRange', {start, end});
}

function dayClick({date}) {
    emit('dayClick', date);
}

function timeClick({date, time}) {
    emit('timeClick', {date, time});
}

onMounted(() => {
    $refs.calendar.checkChange()
});

</script>

<template>
    <v-row class="fill-height">
        <v-col>
            <v-sheet height="64">
                <v-toolbar
                    flat
                    height="40"
                >
                    <v-btn
                        small
                        outlined
                        class="mr-4"
                        color="grey darken-2"
                        @click="setToday"
                    >
                        {{ $t('common.today') }}
                    </v-btn>
                    <w-btn-icon
                        icon="mdi-chevron-left"
                        color="grey darken-2"
                        @press="prev"
                   />
                    <w-btn-icon
                        icon="mdi-chevron-right"
                        color="grey darken-2"
                        @press="next"
                    />
                    <v-toolbar-title v-if="$refs.calendar">
                        {{ $refs.calendar.title }}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-menu
                        bottom
                        right
                    >
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                outlined
                                small
                                color="grey darken-2"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <span>{{ typeToLabel[type] }}</span>
                                <v-icon right>
                                    mdi-menu-down
                                </v-icon>
                            </v-btn>
                        </template>
                        <v-list>
                            <v-list-item @click="type = 'day'">
                                <v-list-item-title>Jour</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'week'">
                                <v-list-item-title>Semaine</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = 'month'">
                                <v-list-item-title>Mois</v-list-item-title>
                            </v-list-item>
                            <v-list-item @click="type = '4day'">
                                <v-list-item-title>4 Jours</v-list-item-title>
                            </v-list-item>
                        </v-list>
                    </v-menu>
                </v-toolbar>
            </v-sheet>
            <v-sheet height="600">
                <v-calendar
                    ref="calendar"
                    v-model="focus"
                    color="primary"
                    first-time="06:00"
                    :events="events"
                    :event-color="getEventColor"
                    :type="type"
                    @click:event="showEvent"
                    @click:more="viewDay"
                    @click:date="viewDay"
                    @click:day="dayClick"
                    @click:time="timeClick"
                    @change="updateRange"
                    locale="fr-fr"
                ></v-calendar>
                <!--<v-menu
                    v-model="selectedOpen"
                    :close-on-content-click="false"
                    :activator="selectedElement"
                    offset-x
                >
                    <v-card
                        color="grey lighten-4"
                        min-width="350px"
                        flat
                    >
                        <v-toolbar
                            :color="selectedEvent.color"
                            dark
                        >
                            <v-btn icon>
                                <v-icon>mdi-pencil</v-icon>
                            </v-btn>
                            <v-toolbar-title v-html="selectedEvent.name"></v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon>
                                <v-icon>mdi-heart</v-icon>
                            </v-btn>
                            <v-btn icon>
                                <v-icon>mdi-dots-vertical</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <span v-html="selectedEvent.details"></span>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                text
                                color="secondary"
                                @click="selectedOpen = false"
                            >
                                Cancel
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-menu>-->
            </v-sheet>
        </v-col>
    </v-row>
</template>
<style scoped>

</style>